const { darken, lighten } = require("polished");

// Used so hover colors get automatically updated
const brandPrimaryColor = "#164397";
const brandSecondaryColor = "#dd412a";
const brandBlackColor = "#222222";
const brandGreyColor = "#d8d8d8";
const brandWhiteColor = "#FFFFFF";

const colors = {
    // Brand & Accent
    "brand-primary": brandPrimaryColor,
    "brand-secondary": brandSecondaryColor,

    // Base
    "brand-black": brandBlackColor,
    "brand-dark-grey": "#575757",
    "brand-grey": brandGreyColor,
    "brand-light-grey": "#f3f3f3",
    "brand-white": brandWhiteColor,

    // Copied from previous site
    "brand-blue": "#164397",
    // "brand-blue-old": "#2A2A7E", // keeping for reference as this was the previous brand blue
    "brand-light-blue": "#5979b4",
    "brand-dark-green": "#00883f",
    "brand-green": "#2cb200",
    "brand-red": "#dd412a",
    "brand-yellow": "#F08C28",
    "brand-pale-blue": "#dce3f0",
    "brand-pale-red": "#FDF1F2",
    "brand-pale-green": "#E9F7E5",

    // Messages
    "brand-success": "#2cb200",
    "brand-warning": "#F08C28",
    "brand-danger": "#dd412a",
    "brand-info": "#5979b4",

    // Alerts
    "brand-success-alert": "#E9F7E5",
    "brand-warning-alert": "#FEF5E6",
    "brand-danger-alert": "#FCE5E7",
    "brand-info-alert": "#E5F4FC",

    // Alert Borders
    "brand-success-alert-border": "#D5F0CE",
    "brand-warning-alert-border": "#FDECD0",
    "brand-danger-alert-border": "#F9CED2",
    "brand-info-alert-border": "#CEEAF9",

    // Checkbox Count
    "brand-checkbox-count": "#909090",

    // Lighten & Darken
    "brand-primary-lighten": lighten(0.05, brandPrimaryColor),
    "brand-primary-darken": darken(0.05, brandPrimaryColor),

    "brand-secondary-lighten": lighten(0.05, brandSecondaryColor),
    "brand-secondary-darken": darken(0.05, brandSecondaryColor),

    "brand-black-lighten": lighten(0.05, brandBlackColor),
    "brand-black-darken": darken(0.05, brandBlackColor),

    "brand-grey-lighten": lighten(0.05, brandGreyColor),
    "brand-grey-darken": darken(0.05, brandGreyColor),

    "brand-white-lighten": lighten(0.05, brandWhiteColor),
    "brand-white-darken": darken(0.05, brandWhiteColor),
};

const fonts = {
    heading: ["Roboto, sans-serif"],
    body: ["Roboto, sans-serif"],
};

module.exports = { colors, fonts };
